import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose, graphql } from 'react-apollo';
import { getPackageById } from "../../graphqlDic";
import PackageDetail from '../../components/Scoin/PackageDetail';

export default compose(graphql(getPackageById, {
    name: 'getPackageById',
    options: (ownProps) => ({
        variables: {
            id: ownProps.match.params.id
        }
    })
}))(withRouter(
    connect(
        null,
        null
    )(PackageDetail)
)
);


// WEBPACK FOOTER //
// ./src/containers/Scoin/PackageDetail.js